module.exports = __webpack_public_path__ + "static/media/167.a8ea1b97.jpg";